import { useRef } from 'react';
import { Configure, Index, useSearchBox, RefinementList } from 'react-instantsearch';
import { useTranslation } from '@klv/hooks/useTranslation';

import Buttons from '@klv/molecules/buttons';
import FilterAccordion from '@klv/atoms/filter-accordion';
import UnifiedSearchInput from '@klv/molecules/unified-search-input';
import WhatsNewResults from '@klv/molecules/whats-new-results';
import { accordionToggles, toggleButton } from '@klv/organisms/unified-search/styles/unified-search.module.css';
import useCollapseRefinements from '@klv/hooks/useCollapseRefinements';

import * as styles from './styles/whatsNewTimeline.module.css';
import SearchFilterLayout from '../search-filter-layout';
import type { IWhatsNewRefinementListItem, IWhatsNewTimeline } from './types';
import ClearAll from './clear-all';


const UnifiedSearchForm = ({ whatsNewUpdates, ctaBody, ctaHeadline, buttons, backgroundColor }: IWhatsNewTimeline) => {
  const { t } = useTranslation();
  const indexName = process.env.GATSBY_ALGOLIA_WHATS_NEW_INDEX as string;
  const searchBox = useRef<HTMLInputElement>(null);
  const { refine } = useSearchBox();

  const translateRefinements = (items: IWhatsNewRefinementListItem[]) => {
    return items.filter(item => {
      item.label = t(`organisms_whatsNew_refinements_${item.label}`);
      return item;
    });
  };

  const collapseRefinements = useCollapseRefinements();

  return (
    <Index indexName={indexName}>
      <div className={styles.whatsNewTimeline}>
        <SearchFilterLayout
          headline={t('organisms_whatsNew_filterTitle')}
          search={<UnifiedSearchInput searchBox={searchBox} placeholder={t('organisms_whatsNew_placeholder')}/>}
          filters={(<>
            <div className={accordionToggles}>
              <button 
                className={toggleButton} 
                type="button" 
                onClick={collapseRefinements}>
                  {t('organisms_whatsNew_collapseAll')}
              </button>
              <ClearAll refine={refine} searchBox={searchBox}/>
            </div>
            <div className="refinements">
              <FilterAccordion label={t('organisms_whatsNew_refinements_topic')} className="includeDesktop">
                <RefinementList limit={100} attribute="topic" transformItems={translateRefinements}/>
              </FilterAccordion>
              {ctaHeadline && (<div className={styles.ctaHeadline}>{ctaHeadline}</div>)}
              {ctaBody && (<p className={styles.ctaBody}>{ctaBody}</p>)}
              {!!buttons?.length && (<Buttons buttons={buttons} buttonColor="dark" variants={['primary']}/>)}
            </div>
          </>)}
          results={<>
            <Configure hitsPerPage={1000} filters={`locale:${t('langCodes_locale')}`}/>
            <WhatsNewResults whatsNewUpdates={whatsNewUpdates} backgroundColor={backgroundColor} />
          </>}
        />
      </div>
    </Index>
  );
};

export default UnifiedSearchForm;
